import { render, staticRenderFns } from "./ComixBreadcrumbs.vue?vue&type=template&id=2286e1bc&scoped=true&"
import script from "./ComixBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ComixBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ComixBreadcrumbs.vue?vue&type=style&index=0&id=2286e1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286e1bc",
  null
  
)

export default component.exports